import { useQuery } from '@tanstack/react-query';

import { Batch } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useBatch = (id: string) =>
  useQuery({
    queryKey: ['batch', id],
    queryFn: async (): Promise<Batch> => {
      try {
        const { data } = await request({
          path: `batches/${id}`,
          method: 'GET',
          authenticate: true,
        });

        return data?.batch;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch the batch details');
      }
    },
    enabled: !!id,
  });
